


















import { Component, Vue } from 'vue-property-decorator';
import { BaseGetter, SearchGetter } from '@/store/getters';

interface CustomOr {
  OR: OR[];
}

interface OR {
  stepId: string;
}

@Component({
  name: 'no-results-component',
})
export default class NoResultsComponent extends Vue {
  private where !: CustomOr;

  // <editor-fold desc="Init">
  // eslint-disable-next-line class-methods-use-this
  private mounted(): void {
    setTimeout(() => {
      window.components.import('tile-collection');
    }, 150);
  }

  private created(): void {
    this.where = {
      ...this.where,
      ...{
        OR: [
          { stepId: 'FC-4191540' },
          { stepId: 'FC-4340066' },
          { stepId: 'FC-4311399' },
          { stepId: 'FC-4252039' },
        ],
      },
    };
  }

  // </editor-fold>
  get country(): string {
    return this.$store.getters[BaseGetter.Country];
  }

  get storeSearchTerm(): string {
    return this.$store.getters[SearchGetter.SearchTerm];
  }
}
